import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslateDirective } from './directives/translate.directive';

@NgModule({
  declarations: [TranslatePipe, TranslateDirective],
  imports: [CommonModule],
  exports: [TranslatePipe, TranslateDirective]
})
export class SharedTranslationModule {}
